export const environment = {
  url: {
    api: `https://apim-dev.houseofhr.com/square-app-avanti/api/v2.0`,
  },
  production: false,
  ocpApimSubscriptionKey: 'c505895c74674cfd9593102056d6fed5'
};

